/**
 * Serverrenderad metadata för lokala sidor (tjänst + kommun).
 *
 * Titel och beskrivning hämtas ur samma data som sidan renderar, så de finns
 * i serverns HTML i stället för att sättas först efter hydrering.
 */

import { municipalityBySlug } from "@/data/municipalities";
import { verticalBySlug } from "@/data/localVerticals";
import { buildOfferTitle } from "./seoTitles";
import { seoHead, type SeoHeadOptions } from "./seoHead";

/** head() för /<tjänst>/<kommun>, t.ex. /solceller/stockholm. */
export function localVerticalHead(vertical: string, slug: string, options: SeoHeadOptions = {}) {
  const path = `/${vertical}/${slug}`;
  const kommun = municipalityBySlug(slug);
  const config = verticalBySlug(vertical);
  if (!kommun || !config) return seoHead(path, options);

  return seoHead(path, {
    title: buildOfferTitle(config.pageTitle(kommun.displayName)),
    description: config.metaDescription(kommun.displayName),
    ...options,
  });
}
